<template>
  <div class="staff-practice-partner-configuration" :class="{ 'is-init': isInit }">
    <div class="configuration-container">
      <div class="configuration-container__title">
        <p class="title-text">公司业务介绍</p>
        <p class="title-desc">
          为了让Al更好地模拟真实业务场景，请先输入业务信息，以便在后续的对练中作为背景支撑。
        </p>
      </div>
      <div class="cut-line"></div>
      <div class="configuration-container__content">
        <el-input
          v-model="configuration"
          :maxlength="configurationMaxLength"
          :placeholder="placeholderText"
          show-word-limit
          type="textarea"
        ></el-input>
        <el-button
          v-if="!isInit"
          color="#7a52f4"
          :disabled="!configuration"
          :loading="loading"
          @click="toSave"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useAppStore } from '@/store/useAppStore'
// api
import { getCompanyTrainingIntroduction, saveCompanyTrainingIntroduction } from '@/api/ai-board.js'
// data
const props = defineProps({
  isInit: {
    type: Boolean,
    default: false
  }
})

const appStore = useAppStore()
const configuration = ref('')
const loading = ref(false)
const configurationMaxLength = 1000
const placeholderText = ref(`示例：
    1. 公司名称：［填写公司名］
    2.核心产品/服务：［例如：SaaS 财务系统、工业自动化视觉检测设备、企业员工保险方案］
    3.一句话价值：我们通过［核心技术/方法］，帮助客户解决［核心痛点］
`)
// methods
const toSave = async () => {
  if (loading.value) return
  if (configuration.value.length > configurationMaxLength) {
    ElMessage.warning(`公司业务介绍不能超过${configurationMaxLength}个字符`)
    throw new Error('公司业务介绍长度超出限制')
  }

  loading.value = true
  try {
    await saveCompanyTrainingIntroduction({
      memo: configuration.value
    })
    ElMessage.success('保存成功！')
  } finally {
    loading.value = false
  }
}
// computed
// lice-cycle
onMounted(() => {
  if (props.isInit) {
    const companyDescriptionConfig = appStore.aiInitConfigDetails.find(
      (item) => item.configAlias === 'companyDescriptionConfig'
    )
    configuration.value = companyDescriptionConfig?.aiGeneratedContent || ''
    return
  }

  getCompanyTrainingIntroduction().then((res) => {
    configuration.value = res.result.memo
  })
})

defineExpose({ toSave })
</script>

<style lang="less" scoped>
.staff-practice-partner-configuration {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 12px;

  .configuration-container {
    width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 8px;
    background: #fff;

    &__title {
      .title-text {
        line-height: 22px;
        color: #323233;
        font-weight: 600;
        font-size: 16px;
      }

      .title-desc {
        font-size: 14px;
        margin-top: 4px;
        line-height: 20px;
        color: #969799;
      }
    }

    &__content {
      flex-grow: 1;
      min-height: 0;
      overflow: auto;

      :deep(.el-textarea) {
        .el-textarea__inner {
          font-size: 14px;
          padding: 8px 12px !important;
          min-height: 164px !important;
        }
      }

      :deep(.el-button) {
        margin-top: 18px;
      }
    }

    .cut-line {
      margin: 12px 0 16px;
      border-top: 1px solid #e5e6eb;
    }
  }
}

.staff-practice-partner-configuration.is-init {
  padding: 0;

  .configuration-container {
    height: 100%;
    padding: 0;
  }

  .configuration-container__content {
    display: flex;
    flex-direction: column;

    :deep(.el-textarea) {
      flex: 1;
      min-height: 0;
      display: flex;

      .el-textarea__inner {
        height: 100%;
        min-height: 100% !important;
        resize: none;
      }
    }
  }
}
</style>
